import React from "react";
import { FaShoppingCart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Product.css";

import product1 from "../Images/mens20.jpg";
import product2 from "../Images/mens11.jpg";
import product3 from "../Images/mens12.jpg";
import product4 from "../Images/mens26.png";
import product5 from "../Images/mens16.jpg";
import product6 from "../Images/mens27.png";
import product7 from "../Images/mens28.png";
import product8 from "../Images/mens22.jpg";

// Country / Currency Context
import { useCountry } from "./CountryContext";


/* =========================================
   PRODUCTS DATA
========================================= */

const productsData = [
  {
    id: 1,
    name: "African Dress 1",
    price: 149.99,
    discount: 20,
    img: product1,
  },

  {
    id: 2,
    name: "African Dress 2",
    price: 159.99,
    discount: 15,
    img: product2,
  },

  {
    id: 3,
    name: "African Dress 3",
    price: 129.99,
    discount: 10,
    img: product3,
  },

  {
    id: 4,
    name: "African Dress 4",
    price: 189.99,
    discount: 25,
    img: product4,
  },

  {
    id: 5,
    name: "African Dress 5",
    price: 139.99,
    discount: 5,
    img: product5,
  },

  {
    id: 6,
    name: "African Dress 6",
    price: 169.99,
    discount: 30,
    img: product6,
  },

  {
    id: 7,
    name: "African Dress 7",
    price: 119.99,
    discount: 10,
    img: product7,
  },

  {
    id: 8,
    name: "African Dress 8",
    price: 199.99,
    discount: 20,
    img: product8,
  },
];


/* =========================================
   PRODUCT COMPONENT
========================================= */

function Product() {

  // =========================
  // COUNTRY / CURRENCY
  // =========================

  const { formatPrice } = useCountry();


  // =========================
  // NAVIGATION
  // =========================

  const navigate = useNavigate();


  /* =========================================
     OPEN PRODUCT DETAILS PAGE
  ========================================= */

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };


  /* =========================================
     ADD TO CART BUTTON
     
     IMPORTANT:
     Directly cart me add nahi karenge.
     Pehle Product Details page open hoga
     jahan user size select karega.
  ========================================= */

  const handleAddToCartClick = (productId) => {
    navigate(`/product/${productId}`);
  };


  return (
    <div className="container my-5">


      {/* =====================================
          HEADING
      ===================================== */}

      <h1 className="mens-collection text-center mt-5 mb-5">
        Mens Collection
      </h1>


      {/* =====================================
          PRODUCTS
      ===================================== */}

      <div className="row g-4">

        {productsData.map((item) => {


          /* =========================
             DISCOUNTED PRICE
          ========================= */

          const discountedPrice = Number(
            (
              item.price -
              (item.price * item.discount) / 100
            ).toFixed(2)
          );


          return (

            <div
              key={item.id}
              className="col-6 col-md-3"
            >


              {/* =================================
                  PRODUCT CARD
              ================================= */}

              <div className="product-card shadow-sm p-2 h-100 d-flex flex-column justify-content-between">


                {/* =================================
                    PRODUCT IMAGE
                ================================= */}

                <img
                  src={item.img}
                  alt={item.name}
                  className="img-fluid product-img"
                  data-aos="zoom-in"

                  /*
                    Image click:
                    Product Details page open
                  */

                  onClick={() =>
                    handleProductClick(item.id)
                  }

                  style={{
                    cursor: "pointer",
                  }}
                />


                {/* =================================
                    PRODUCT NAME
                ================================= */}

                <h6 className="mt-2">
                  {item.name}
                </h6>


                {/* =================================
                    PRICE + DISCOUNT
                ================================= */}

                <div className="d-flex justify-content-between align-items-center">


                  {/* CURRENT / DISCOUNTED PRICE */}

                  <span className="price">
                    {formatPrice(discountedPrice)}
                  </span>


                  {/* ORIGINAL PRICE */}

                  <span className="original-price">

                    <s>
                      {formatPrice(item.price)}
                    </s>

                  </span>


                  {/* DISCOUNT */}

                  <span className="discount">
                    {item.discount}% off
                  </span>


                </div>


                {/* =================================
                    ADD TO CART
                ================================= */}

                <button
                  type="button"
                  className="btn1 mt-2 w-100 d-flex align-items-center justify-content-center"

                  /*
                    IMPORTANT:
                    Product directly cart me add nahi hoga.

                    User ko Product Details page par
                    bhejenge.

                    Wahan:
                    1. Size select hoga
                    2. Quantity select hogi
                    3. Add to Cart
                    4. Buy Now
                  */

                  onClick={() =>
                    handleAddToCartClick(item.id)
                  }
                >

                  <FaShoppingCart className="me-2" />

                  Add to Cart

                </button>


              </div>


            </div>

          );

        })}

      </div>


      {/* =====================================
          VIEW ALL BUTTON
      ===================================== */}

      <div className="product-view-all-section">

        <button
          type="button"
          className="product-view-all-btn"

          onClick={() =>
            navigate("/mens")
          }
        >

          View All Mens Collection

        </button>

      </div>


    </div>
  );
}


export default Product;